import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconTrendingUp } from '@tabler/icons-react';
import { CrudMode, CrudSchemaField, type EnsoFormItem } from '@ohpen/enso-ui';
import { TabProps } from '../interfaces';
import { FieldType } from '@pmp/api';
import { Form } from 'antd';

export const ProcFeeBoost: React.FC<TabProps> = ({ form, mode, selectsOptions }) => {
  const { t } = useTranslation();
  const readonly = mode === CrudMode.VIEW;
  const watchedValue = Form.useWatch(['procFeeBoost', 'value'], form);
  const watchedUnit = Form.useWatch(['procFeeBoost', 'unit'], form);

  const unitOptions = selectsOptions[FieldType.PROCURATION_FEE_UNIT];

  const columns: EnsoFormItem[] = useMemo(
    () => [
      {
        valueType: 'group',
        columns: [
          {
            title: t('lender.firms.labels.value'),
            dataIndex: ['procFeeBoost', 'value'],
            valueType: 'digit',
            readonly,
            colProps: { span: 12 },
            formItemProps: {
              rules: watchedUnit ? [{ required: true }] : undefined,
            },
          },
          {
            title: t('lender.firms.labels.unit'),
            dataIndex: ['procFeeBoost', 'unit'],
            valueType: 'select',
            readonly,
            fieldProps: {
              optionFilterProp: 'label',
              options: unitOptions,
              allowClear: true,
            },
            colProps: { span: 12 },
            formItemProps: {
              rules: watchedValue !== null && watchedValue !== undefined ? [{ required: true }] : undefined,
            },
          },
        ],
      },
    ],
    [readonly, t, unitOptions, watchedUnit, watchedValue],
  );

  const schema: EnsoFormItem = useMemo(
    () => ({
      valueType: 'group',
      variant: 'card',
      icon: <IconTrendingUp />,
      title: t('lender.firms.labels.procFeeBoost'),
      columns,
    }),
    [columns, t],
  );

  return <CrudSchemaField item={schema} form={form} readonly={readonly} />;
};
